import Vue from 'vue'
import Router from 'vue-router'
import Landing from './views/Landing.vue'
import Login from './views/Login.vue'
import Create from './views/Create.vue'
import Playground from './views/Playground.vue'
import SignUp from './views/SignUp.vue'
import Dashboard from './views/Dashboard.vue'
import Learn from './views/Learn.vue'
import ManageDeck from './views/ManageDeck.vue'
import Analytics from './views/Analytics.vue'
import Welcome from './views/Welcome.vue'
import Review from './views/Review.vue'
import Browse from './views/Browse.vue'
import ManageContent from './views/ManageContent.vue'
import Outline from './views/Outline.vue'
import Home from './views/Home.vue'
import Account from './views/Account.vue'
import Anki from './views/Anki.vue'
import AlgoPrototype from './algorithm-dev/algoPrototype.vue'
import Lighyear from './lightyear/Lightyear.vue'
import Admin from './views/admin/Admin.vue'
import AdminAnalytics from './views/admin/AdminAnalytics.vue'
import ManageUsers from './views/admin/ManageUsers.vue'
import ContentImporter from './views/admin/ContentImporter.vue'
import DataExport from './views/admin/DataExport.vue'
import DataManagement from './views/admin/DataManagement.vue'
import CohortManagement from './views/admin/CohortManagement.vue'
import AdminManagement from './views/admin/AdminManagement.vue'
import CSVImporter from './views/admin/CSVImporter.vue'


import EmailVerify from './views/EmailVerify.vue'
import TOU from './views/TOU.vue'
import Privacy from './views/Privacy.vue'
import Support from './views/Support.vue'
import QAMetrics from './views/admin/QAmetrics.vue'
import Anking from './anki/Anking.vue'
import Neuro from './proto/Occlude.vue'
import NeuroAtlas from './proto/NeuroAtlas.vue'

import firebase from 'firebase'
import store from './store.js'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing,
      props: true,
      meta: {
        requiresAuth: false
      },
      beforeEnter: (to, from, next) => {
        let user = firebase.auth().currentUser
        if (user) {
          next({name: 'Dashboard'})
        }
        else {
          next()
        }
      }
    },
    {
      path: '/anki',
      name: 'Anki',
      component: Anki,
      props: true,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/neuro',
      name: 'Neuro',
      component: Neuro,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/neuroAtlas',
      name: 'NeuroAtlas',
      component: NeuroAtlas,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/lightyear',
      name: 'Lighyear',
      component: Lighyear,
      props: true,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/anking',
      name: 'Anking',
      component: Anking,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/prototype',
      name: 'AlgoPrototype',
      component: AlgoPrototype,
      props: true,
      meta: {
        requiresAuth: false
      },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Home,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/browse',
      name: 'Browse',
      component: Browse,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/create',
      name: 'Create',
      component: Create,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/learn/:id',
      name: 'Learn',
      component: Learn,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/review/:subject',
      name: 'Review',
      component: Review,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/manage',
      name: 'ManageContent',
      component: ManageContent,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/manage/:id',
      name: 'ManageDeck',
      component: ManageDeck,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/manage/:id/outline',
      name: 'Outline',
      component: Outline,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/playground',
      name: 'Playground',
      component: Playground,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: async (to, from, next) => {

        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {

        if (firebase.auth().currentUser.uid) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/analytics',
      name: 'AdminAnalytics',
      component: AdminAnalytics,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/manageUsers',
      name: 'ManageUsers',
      component: ManageUsers,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/contentImporter',
      name: 'ContentImporter',
      component: ContentImporter,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/CSVImporter',
      name: 'CSVImporter',
      component: CSVImporter,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/dataExport',
      name: 'DataExport',
      component: DataExport,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/dataManagement',
      name: 'DataManagement',
      component: DataManagement,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/cohortManagement',
      name: 'CohortManagement',
      component: CohortManagement,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },
    {
      path: '/admin/adminManagement',
      name: 'AdminManagement',
      component: AdminManagement,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },    


    {
      path: '/qa/metrics',
      name: 'QAMetrics',
      component: QAMetrics,
      props: true,
      meta: {
        requiresAuth: true
      },
      //Admin Block
      beforeEnter: (to, from, next) => {
        if (store.getters.verifyEditor) {
          next()
        }
        else {
          next( {name: 'Home'} )
        }
      }
    },

    {
      path: '/login',
      name: 'Login',
      component: Login,
      props: true,
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      props: true,
    },
    {
      path: '/email',
      name: 'EmailVerify',
      component: EmailVerify,
      props: true,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
      props: true,
    },
    {
      path: '/tou',
      name: 'TOU',
      component: TOU,
      props: true,
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
      props: true,
    },
    {
      path: '/support',
      name: 'Support',
      component: Support,
      props: true,
    },
  ]
})

router.beforeEach((to, from, next) => {
  // scroll to top of page
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

  firebase.analytics().logEvent('page_view', {
    page_title: to.name,
    page_location: window.location.href,
    page_path: window.location.pathname
  })

  //check to see if route requires Auth
  if (to.matched.some(rec => rec.meta.requiresAuth)){
    //check auth state
    let user = firebase.auth().currentUser
    if (user) {
      if(!user.emailVerified && to.name != 'EmailVerify') {
        next({name: 'EmailVerify'})
      }
      else {
        next()
      }

    } else {
      //no user, redirect to Login
      next( {name: 'Welcome', params: {tag: to.query.tag}} )
    }
  } else {
    next()
  }
})

export default router
